import React, { useState, useEffect } from "react";
import college from "../assets/college-church-exterior-rooftop.jpg";
import together from "../assets/together.jpg";
// import collab from "../assets/collab.jpg";
import collab from "../assets/partnership.png";
import {
  timelineEvents,
  institutions,
  updatedTestimonials,
  impactStats,
} from "../data/whoWeAreData";
import Community from "./Community";
import report from "../assets/Impact_Report.pdf";
import TestimonialsSection from "./Testimonials";

const WhoWeAre = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // --- Start of added code for inline autoscroll ---
  useEffect(() => {
    const style = document.createElement("style");
    // Define the keyframe animation and the class to apply it
    style.innerHTML = `
      @keyframes scroll-x-rtl {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(0); }
      }
      .animate-scroll-x-inline {
        /* Adjust the 40s duration to control speed */
        animation: scroll-x-rtl 60s linear infinite; 
      }
      /* Hide scrollbar using pure CSS */
      .scrollbar-none-inline::-webkit-scrollbar { display: none; }
      .scrollbar-none-inline { -ms-overflow-style: none; scrollbar-width: none; }
    `;
    document.head.appendChild(style);

    // Cleanup function
    return () => {
      document.head.removeChild(style);
    };
  }, []); // Empty dependency array ensures this runs only once
  // --- End of added code ---

  // Duplicate testimonials for infinite loop illusion
  const duplicatedTestimonials = [
    ...updatedTestimonials,
    ...updatedTestimonials,
  ];

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = report;
    link.download = "Impact_Report.pdf";
    link.click();
  };

  return (
    <div className="font-[corporate-s] min-h-screen text-[#2b2b2b]">
      <div className="relative">
        <img
          src={college}
          alt="College Church background"
          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-blue-900 opacity-60"> </div>
        <div className="absolute inset-0 flex items-center justify-center p-4">
          <h1 className="text-[2rem] sm:text-[3rem] md:text-[4.25rem] font-bold font-['corporate-s'] text-[#FFF] my-4 text-center">
            Who We Are
          </h1>
        </div>
      </div>

      {/*   <header className="relative h-[300px] md:h-[400px] overflow-hidden">
        <img
          src={college}
          alt="College Church background"
          className="absolute inset-0 w-full h-full object-cover"
        />
         <div className="absolute inset-0 bg-blue-900 opacity-60"> </div>
         <div className="absolute inset-0 flex items-center justify-center p-4">
      <h1 className="text-[1.25rem] sm:text-[2rem] md:text-[3.25rem] font-bold font-['corporate-s'] text-[#FFF] my-4 text-center">
        Who We Are
        </h1>
    </div>
      </header> */}

      {/* COLOR BLOCK SECTION */}

        {/* OVERLAPPING CONTENT BOX */}
      <section className="relative bg-gray-200 py-16 h-[50px] md:h-[150px]">
    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center px-6">
          <div className="bg-white relative p-6 md:px-6 md:w-[300px] shadow-xl mx-auto max-w-sm h-lg md:max-w-xl">
            <h2 className="text-md sm:text-xl md:text-2xl font-bold font-['corporate']  mb-4 text-[#003DA5] text-center">
              SLU TWA serves as a practical extension of Saint Louis
              University's Jesuit mission.
            </h2>
            <p className="text-sm sm:text-md justify-center font-['corporate-s'] text-left">
              The SLU Transformative Workforce Academy (TWA) embody’s a faith
              that does justice by directly addressing systemic inequalities and
              empowering individuals through education and employment and
              promotes human dignity, social equity, and inclusion
            </p>
          </div>
        </div>
      </section>

      {/* NAV CARDS */}
      <section className="pt-40 pb-12">
        <div className="max-w-4xl h-50 mx-auto px-6 sm:px-10 md:px-16 lg:px-20 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            { title: "Mission", color: "#003DA5", id: "mission" },
            { title: "Impact", color: "#FFC72C", id: "impact" },
            { title: "Team", color: "#668ac9", id: "team" },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white p-6 flex flex-col justify-center items-center shadow-lg/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-l-4 cursor-pointer"
              onClick={() => (window.location.href = `#${item.id}`)}
              style={{ borderColor: item.color }}
            >
              <h3
                className="text-3xl sm:text-4xl md:text-5xl font-bold font-['corporate-s'] "
                style={{ color: item.color }}
              >
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </section>

      <section id="mission" className="py-16 bg-white">
        {/* === CONSTRAINED CONTENT AREA === */}
        <div className="mx-auto max-w-7xl md:pr-20 px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-y-8 md:gap-x-6">
            {/* === MISSION HEADING === */}
            <div className="md:col-start-2 flex justify-center md:justify-start">
              <h2 className="text-4xl sm:text-5xl font-bold text-[#003DA5] font-['corporate-s'] text-center md:text-left tracking-tight text-center flex flex-row items-center py-3">
                Mission
              </h2>
            </div>

            {/* === MISSION PARAGRAPH === */}
            <div className="md:col-start-3 md:col-span-3">
              <p className="font-['farnham-display'] text-xl md:text-3xl leading-tight">
                Empowering justice-involved individuals through comprehensive
                support and meaningful employment opportunities.
              </p>
            </div>

            {/* === MISSION CONTENT BOX === */}
            <div className="md:col-start-3 md:col-span-3">
              <div className="bg-[#f0f0f0] p-6 mt-6">
                <div className="border-l-6 border-[#FFC72C] pl-6">
                  <p className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                    The Transformative Workforce Academy is part of a Saint
                    Louis University interdepartmental collaboration designed to
                    support and integrate those in Missouri most at risk of and
                    impacted by incarceration so we can all live fruitful,
                    prison-free lives.
                    <br />
                    TWA's focus is helping those who are justice-involved,
                    especially those recently coming out of prison, find and
                    retain meaningful employment.
                  </p>
                </div>
              </div>
            </div>

            {/* === VISION HEADING === */}
            <div className="md:col-start-3 md:col-span-3">
              <h2 className="text-5xl font-bold py-8 font-['corporate-s'] text-[#668ac9] text-center md:text-left tracking-tight">
                Vision
              </h2>
            </div>

            {/* === VISION CONTENT BOX === */}
            <div className="md:col-start-3 md:col-span-3">
              <div className="bg-[#f0f0f0] p-6 mb-8">
                <div className="border-l-6 border-[#FFC72C] pl-6">
                  <p className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                    SLU's initiatives engage the whole lifespan, including
                    prevention, in-prison, and reentry services. Through
                    research, information-sharing, and direct services in areas
                    such as education, legal defense, life skills training, and
                    employment placement, SLU seeks to address the root causes
                    of crime by providing support and resources to those who all
                    too often see no alternative.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FULL-WIDTH BLUE BANNER*/}
        <div className="w-full md:w-full relative mt-16">
          <div className="bg-[#003DA5]">
            <div className="grid grid-cols-1 md:grid-cols-3 items-center">
              {/* Text — constrained */}
              <div className="md:col-span-2 p-8 md:p-12 text-white order-2 md:order-1">
                <div className="mx-auto max-w-7xl md:px-0 px-4 sm:px-6">
                  <p className="text-xl md:text-3xl font-['farnham-display'] leading-relaxed">
                    As part of SLU’s effort, TWA's focus is preparing and
                    connecting justice-involved jobseekers with vetted fair
                    chance employers to find and retain meaningful employment.
                  </p>
                </div>
              </div>
              {/* Image — full bleed */}
              <img
                src={together}
                alt="Program Information"
                className="w-full h-full object-cover md:col-start-3 order-1 md:order-2"
              />
            </div>
          </div>
        </div>

        <div className="mx-auto max-w-7xl md:pr-20 px-4 sm:px-6 mt-16">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-y-8 md:gap-x-6">
            <div className="md:col-start-3 md:col-span-3">
              <p className="text-5xl font-bold text-center md:text-left text-[#668ac9] tracking-tight">
                History
              </p>
              <div className="bg-[#f0f0f0] p-6 mt-6">
                <div className="border-l-6 border-[#FFC72C] pl-6">
                  <div className="space-y-8">
                    {timelineEvents.map((event, index) => (
                      <div
                        key={index}
                        className="flex flex-col md:flex-row items-start gap-6 bg-gray-50 rounded-xl p-8 hover:bg-gray-100 transition-colors"
                      >
                        <div className="flex items-center justify-center w-20 h-20 bg-[#003DA5] text-white rounded-full text-2xl font-bold flex-shrink-0">
                          {event.year}
                        </div>
                        <div>
                          <h4 className="text-2xl font-bold mb-3 text-[#00244D] font-['corporate-s']">
                            {event.title}
                          </h4>
                          <p className="text-gray-600 leading-relaxed font-['corporate-s']">
                            {event.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="impact">
        {/* Top Row: Heading + Paragraph */}
        <div className="mx-auto max-w-7xl md:pr-20 px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-5 grid grid-cols-1 md:grid-cols-5 gap-y-8 md:gap-x-6 justify-center">
            <div className="text-center col-span-1 md:col-start-2 flex flex-col sm:flex-row items-center py-3">
              {/* Heading */}
              <h2 className="text-4xl sm:text-5xl font-bold text-[#FFC72C] font-['corporate-s'] md:col-span-1 text-center tracking-tight">
                Impact
              </h2>
            </div>
            <div className="col-span-1 md:col-start-3 md:col-span-3 justify-center">
              <p className="font-['farnham-display']  md:py-8 text-xl md:text-3xl leading-tight">
                TWA is making a measurable difference by reducing recidivism,
                and helping our jobseekers rebuild thier live
              </p>
            </div>
            <div className="col-span-1 md:col-start-3 md:col-span-3 justify-center">
              {/* Content Box */}
              <div className="bg-[#f0f0f0] p-6 mt-6">
                {/* Yellow Line */}
                <div className="border-l-6  border-[#FFC72C] pl-6">
                  {/* Content */}
                  <div className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                    <p>
                      76% of jobseekers securing work within two months and a
                      recidivism rate of just 7.1% among those employed through
                      TWA partners, the outcomes highlight the power of second
                      chances. Employers also benefit through cost savings and
                      access to a dedicated workforce. By advancing economic
                      opportunity, strengthening communities, and promoting
                      safer, more inclusive workplaces, TWA’s impact reaches far
                      beyond individual job placements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-1 md:col-start-3 md:col-span-3 flex flex-col items-center md:items-start text-center md:text-left">
              {/* Key Statistics */}
              <div className="py-6 mb-16">
                <div className="flex md:py-8">
                  <h2 className="text-5xl text-left font-bold font-['corporate-s'] text-[#668ac9] tracking-tight">
                    Key Statistics
                  </h2>
                </div>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-10">
                  {impactStats.map((stat, index) => (
                    <div
                      key={index}
                      className="bg-white border-t-4 border-[#FFC72C] transition-shadow"
                    >
                      <div className="text-6xl md:text-6xl font-light font-['farnham-display'] text-[#003DA5] mb-2">
                        {stat.number}
                      </div>
                      <h4 className="text-xl font-semibold mb-2 text-[#003DA5] font-['farnham-display']">
                        {stat.label}
                      </h4>
                      <p className="text-md font-['corporate-s']">
                        {stat.description}
                      </p>
                    </div>
                  ))}
                </div>
                {/* Modal */}
                {isModalOpen && (
                  <div
                    aria-modal="true"
                    role="dialog"
                    className="fixed inset-0 z-50 flex items-center justify-center p-6"
                  >
                    <div
                      className="fixed inset-0 bg-black/50 flex items-center justify-center"
                      onClick={() => setIsModalOpen(false)}
                    >
                      <div className="relative bg-white max-w-lg w-full rounded-xl p-6 shadow-lg z-10">
                        <button
                          onClick={() => setIsModalOpen(false)}
                          className="absolute top-3 right-3 text-gray-500 cursor-pointer hover:text-gray-800"
                        >
                          ✕
                        </button>
                        <h3 className="text-2xl font-bold mb-4 text-[#003DA5] font-['corporate-s']">
                          Download Impact Report
                        </h3>

                        <iframe
                          src={report}
                          title="Impact Report"
                          className="w-full h-84 rounded-lg mb-4"
                        />
                        <p className="text-gray-600 mb-6 font-['corporate-s']">
                          View our detailed impact report showcasing our
                          achievements and contributions.
                        </p>
                        <button
                          onClick={handleDownload}
                          className="w-full px-6 py-3 bg-[#00244D] text-[#f0f0f0] rounded-lg font-semibold font-['corporate-s'] hover:bg-[#003DA5] transition-all duration-300"
                        >
                          Download Report
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* Impact Report Button */}
                <div className="flex md:py-8 justify-end">
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="absolute cursor-pointer mt-10 flex items-center text-center justify-end gap-2 px-3 py-6  border-2
               border-[#003DA5] text-[#003DA5] font-semibold font-['corporate-s'] transition-all duration-300"
                  >
                    Download Impact Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-1 md:col-start-1 md:col-span-7 justify-center mt-20">
          <div className="relative w-full sm:w-full bg-[#003DA5]">
            <div className="grid grid-cols-1 md:grid-cols-3 items-center">
              {/* Image column */}
              <img
                src={collab}
                alt="Program Information"
                className="md:col-start-1 w-full h-full object-cover"
              />

              {/* Text column */}
              <div className="md:col-span-2 p-8 md:p-12 text-white order-2 md:order-1">
                <p className="text-xl md:text-3xl font-['farnham-display'] leading-relaxed">
                  In partnership with the Missouri Department of Corrections,
                  TWA offers services across 4 regions in Missouri: St. Louis,
                  Kansas City, Springfield and Columbia.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto max-w-8xl px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-5 justify-center">
            <div className="col-span-1 md:col-start-2 md:col-span-7 justify-center">
              {/* MO DOC Institutions */}
              <div className="grid grid-cols-1 place-items-center mt-10 md:grid-cols-3 md:gap-46">
                <div className="  md:col-span-1 w-[350px] text-[#595d80] my-8">
                  <h4 className="text-3xl font-bold font-['farnham-display'] mb-8 text-left">
                    MO DOC Pre-Release support begins 6 months prior to re-entry
                  </h4>
                  <div className="bg-white text-center border-t-4 border-[#FFC72C] transition-shadow ml-4 mr-18">
                    <div className="text-[120px] font-semi-bold text-[#003DA5] leading-none mb-1">
                      5
                    </div>
                    <h4 className="text-xl font-semibold mb-1 text-gray-800 font-['corporate-s']">
                      Missouri Department of Corrections Facilities
                    </h4>
                    <p className="text-gray-600 text-left text-sm font-['corporate-s']">
                      In partnership with SLU TWA for Pre-release
                    </p>
                  </div>
                </div>
                <div className="justify-center w-full md:col-span-2 px-10 sm:px-10 md:pr-30 space-y-4">
                  {institutions.map((institution, index) => {
                    // Extract acronym (anything inside parentheses)
                    const match = institution.match(/\(([^)]+)\)/);
                    const acronym = match ? match[1] : "";
                    // Remove the acronym from the full name
                    const fullName = institution.replace(/\s*\(.*?\)\s*/g, "");

                    return (
                      <div
                        key={index}
                        className="bg-[#FFC72C] p-2  text-center"
                      >
                        {/* hover:shadow-2xl transition-shadow backdrop-blur-sm */}
                        <div className="flex flex-col items-center">
                          <span className="text-xl font-bold text-white">
                            {acronym}
                          </span>
                          <span className="text-sm font-medium text-white">
                            {fullName}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col-span-1 md:col-start-3 my-12 md:col-span-3 justify-center">
              <h2 className="text-5xl text-center md:text-left font-bold font-['corporate-s'] text-[#668ac9]">
                Testimonials
              </h2>
            </div>
            <div className="col-span-1 md:col-start-1 md:col-span-8 flex justify-center overflow-hidden">
              <TestimonialsSection />
            </div>
            {/* Auto-scroll container: Change overflow-x-auto to overflow-hidden and add scrollbar-none-inline class */}
            {/* Apply the custom animation class here: animate-scroll-x-inline and keep w-max */}
            {/* Use the duplicated array here */}
            {/* <div className="col-span-1 md:col-start-1 md:col-span-7 flex justify-center">
            
              <div className="overflow-hidden pb-4 w-full max-w-4xl scrollbar-none-inline">
              
                <div className="flex gap-8 w-max mx-auto animate-scroll-x-inline">
                
                  {duplicatedTestimonials.map((testimonial, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow w-80 flex-shrink-0"
                    >
                      <div className="text-4xl text-[#003DA5] mb-4">
                        <FaUser />
                      </div>

                      <p className="text-[#00244D] leading-relaxed mb-6 italic">
                        {testimonial.quote}
                      </p>

                      <div className="border-t pt-4">
                        <div className="font-semibold text-[#00244D]">
                          {testimonial.name}
                        </div>
                        <div className="text-sm text-[#00244D]">
                          {testimonial.role}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section id="team" className="py-16 ">
        {/* Top Row: Heading + Paragraph */}
        <div className="mx-auto max-w-7xl md:pr-20 px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-y-8 md:gap-x-6">
            {/* Heading */}
            <div className="md:col-start-2 flex justify-center md:justify-start">
              <h2 className="text-4xl sm:text-5xl font-bold font-['corporate-s'] text-center md:text-left tracking-tight text-[#668ac9] flex justify-center items-center">
                Team
              </h2>
            </div>

            {/* Paragraph */}
            <div className="md:col-start-3 md:col-span-3">
              <p className="font-['farnham-display']  md:py-8 text-xl md:text-3xl leading-tight">
                Contact one of our dedicated professionals, who are passionate
                about creating pathways to success in the communities we serve.
              </p>
            </div>

            {/* Content Box + Community */}
            <div className="md:col-start-3 md:col-span-3">
              <div className="bg-[#f0f0f0] p-6 my-6">
                {/* Yellow Line */}
                <div className="border-l-6 border-[#FFC72C] pl-6">
                  <div className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                    <p>
                      Click on a TWA region listed below to reach out to the
                      local contact.
                    </p>
                  </div>
                </div>
              </div>
              <Community />
            </div>
          </div>
        </div>
      </section>

      {/*<section>
        <div className="px-10 sm:pl-20 md:pl-50 mt-10" >
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-15">
          {/* Heading 
            <h2 className="text-4xl text-left font-bold font-['corporate-s'] text-[#FFC72C]text-4xl sm:text-5xl font-bold text-[#003DA5] font-['corporate-s'] md:col-span-1">
              Impact
            </h2>

          {/* Main Paragraph 
          <div className="space-y-6 pr-40 md:col-span-3">
            <p className="font-bold text-gray-600 text-2xl sm:text-3xl leading-tight">
              TWA is making a measurable difference by reducing recidivism, and
              helping our jobseekers rebuild thier live
            </p>

            {/* Content Box 
            <div className="bg-[#f0f0f0] pl-6 w-full mt-6 md:w-full relative p-6 sm:p-6">
              {/* Yellow Line *
              <div className="border-l-6 border-[#FFC72C] ml-4 px-3 pl-8">
                <div className="font-['corporate-s'] text-gray-800 pl-6 mr-18 text-sm sm:textbase leading-relaxed">
                  <p>
                    76% of jobseekers securing work within two months and a
                    recidivism rate of just 7.1% among those employed through
                    TWA partners, the outcomes highlight the power of second
                    chances. Employers also benefit through cost savings and
                    access to a dedicated workforce. By advancing economic
                    opportunity, strengthening communities, and promoting safer,
                    more inclusive workplaces, TWA’s impact reaches far beyond
                    individual job placements.
                  </p>
                </div>
              </div>
            </div>
            {/* Key Statistics 
            <div className="mb-16">
              <div className="flex p-4 md:p-4">
                <h2 className="text-5xl text-left font-bold font-['corporate-s'] text-[#305183]">
                  Key Statistics
                </h2>
              </div>
              <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-20 mt-10">
                {impactStats.map((stat, index) => (
                  <div
                    key={index}
                    className="bg-white border-t-4 border-[#FFC72C] hover:shadow-xl transition-shadow"
                  >
                    <div className="text-7xl  text-[#003DA5] mb-2">
                      {stat.number}
                    </div>
                    <h4 className="text-xl font-semibold mb-2 text-gray-800 font-['HVD_Trial_Brandon_Grotesque']">
                      {stat.label}
                    </h4>
                    <p className="text-gray-600 text-sm font-['corporate-s']">
                      {stat.description}
                    </p>
                  </div>
                ))}
              </div>
                {/* Modal *
            {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="absolute inset-0 bg-gray-100 bg-opacity-75 pointer-events-none"></div>
                <div className="relative bg-white rounded-xl p-8 max-w-lg w-full mx-4 shadow-2xl">
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                    aria-label="Close modal"
                  >
                    ✕
                  </button>
                  <h3 className="text-2xl font-bold mb-4 text-[#003DA5] font-['HVD_Trial_Brandon_Grotesque']">
                    Download Impact Report
                  </h3>

                  <iframe
                    src={report}
                    title="Impact Report"
                    className="w-full h-64 rounded-lg mb-4"
                  />
                  <p className="text-gray-600 mb-6 font-['corporate-s']">
                    View our detailed impact report showcasing our achievements
                    and contributions.
                  </p>
                  <button
                    onClick={handleDownload}
                    className="w-full px-6 py-3 bg-[#00244D] text-[#f0f0f0] rounded-lg font-semibold font-['corporate-s'] hover:bg-[#003DA5] transition-all duration-300"
                  >
                    Download Report
                  </button>
                </div>
              </div>
            )}
            {/* Impact Report Button *

            <button
              onClick={() => setIsModalOpen(true)}
              className="absolute right-60 mt-10 flex float-right text-center justify-end gap-2 px-3 py-6 bg-[#FFD700]  text-white font-semibold font-['corporate-s'] hover:bg-[#00244D] hover:text-[#f0f0f0] transition-all duration-300"
            >
              Download Impact Report
            </button>
            </div>
          </div>
        </div>

        {/* Full-width blue section *
        <div className="relative w-screen sm:w-screen left-1/2 right-1/2 -mx-[57vw] bg-[#4C6B99]">
          <div className="grid md:grid-cols-2 items-center">
            {/* Image column *
              <img
                src={work}
                alt="Program Information"
                className="w-full h-full object-cover"
              />

            {/* Text column *
            <div className="p-12 sm:p-10 md:p-20 text-white">
              <h2 className="text-2xl sm:text-3xl font-bold leading-relaxed">
                In partnership with the Missouri Department of Corrections, TWA
                offers services across 4 regions in Missouri: St. Louis, Kansas
                City, Springfield and Columbia.
              </h2>
            </div>
          </div>
        </div>

        {/* MO DOC Institutions *
        <div className="grid grid-cols-1 mt-10 md:grid-cols-3 gap-46">
          <div className=" md:col-span-1 text-[#795D3E] mb-8">
            <h4 className="text-4xl font-bold mb-8 text-left">
              MO DOC Pre-Release support begins 6 months prior to reentry
            </h4>
            <div className="bg-white text-center border-t-4 border-[#FFC72C] hover:shadow-xl transition-shadowbg-white text-center border-t-4 ml-4 mr-18 border-[#FFC72C] hover:shadow-xl transition-shadow">
              <div className="text-[120px] font-semi-bold text-[#003DA5] leading-none mb-1">
                5
              </div>
              <h4 className="text-xl font-semibold mb-1 text-gray-800 font-['HVD_Trial_Brandon_Grotesque']">
                MODOC Facilities
              </h4>
              <p className="text-gray-600 text-left text-sm font-['corporate-s']">
                In partnership with SLU TWA for Pre-release
              </p>
            </div>
          </div>
          <div className="justify-start w-full md:col-span-2 pr-30 space-y-4">
            {institutions.map((institution, index) => {
              // Extract acronym (anything inside parentheses)
              const match = institution.match(/\(([^)]+)\)/);
              const acronym = match ? match[1] : "";
              // Remove the acronym from the full name
              const fullName = institution.replace(/\s*\(.*?\)\s*g, "");

              return (
                <div
                  key={index}
                  className="bg-[#FFC72C] p-2 backdrop-blur-sm text-center"
                >
                  <div className="flex flex-col items-center">
                    <span className="text-xl font-bold text-white">
                      {acronym}
                    </span>
                    <span className="text-sm font-medium text-white">
                      {fullName}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* Testimonials 
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-15">
          <h3 className="text-4xl font-bold ml-72 mb-12 text-start text-[#003DA5] font-['corporate-s']">
            Testimonials
          </h3>
          <div className="mt-10 relative">
            <div className="relative -left-[360px] w-screen">
              <div className="overflow-x-hidden pb-4">
                <div className="flex gap-8 p-4 w-max">
                  {updatedTestimonials.map((testimonial, index) => (
                    <div
                      key={index}
                      className="bg-white p-2 shadow-lg hover:shadow-xl transition-shadow w-70 flex-shrink-0"
                    >
                      <div className="text-4xl text-[#003DA5] mb-4">"</div>
                      <p className="text-[#00244D] leading-relaxed mb-6 italic">
                        {testimonial.quote}
                      </p>
                      <div className="border-t pt-4">
                        <div className="font-semibold text-[#00244D]">
                          {testimonial.name}
                        </div>
                        <div className="text-sm text-[#00244D]">
                          {testimonial.role}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          </div> *
          </div>
                    {/* Testimonials *
          <div className="mb-16">
            <h3 className="text-4xl font-bold mb-12 text-center text-[#003DA5] font-['corporate-s']">
              TESTIMONIALS
            </h3>
            <div className="overflow-x-auto pb-4">
              <div className="flex gap-8 w-max">
                {updatedTestimonials.map((testimonial, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow w-80 flex-shrink-0"
                  >
                    <div className="text-4xl text-[#003DA5] mb-4">"</div>
                    <p className="text-[#00244D] leading-relaxed mb-6 italic">
                      {testimonial.quote}
                    </p>
                    <div className="border-t pt-4">
                      <div className="font-semibold text-[#00244D]">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-[#00244D]">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
      </section>

      <section id="team" className="px-10 sm:pl-20 md:pl-50 mt-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-15">
          {/* Heading *
            <h2 className="text-4xl text-left font-bold font-['corporate-s'] text-[#FFC72C]text-4xl sm:text-5xl font-bold text-[#003DA5] font-['corporate-s'] md:col-span-1">
              Team
            </h2>

          {/* Main Paragraph *
          <div className="space-y-6 pr-40 md:col-span-3">
            <p className="font-bold text-gray-600 text-2xl sm:text-3xl leading-tight">
              Contact one of our dedicated professionals, who are passionate
              about creating pathways to success in the communites we serve.
            </p>

            {/* Content Box *
            <div className="bg-[#f0f0f0] pl-6 w-[calc(100%+10rem)] mt-6 md:w-[calc(100%+12rem)] relative p-6 sm:p-6">
              {/* Yellow Line *
              <div className="border-l-6 border-[#FFC72C] ml-4 px-3 pl-8">
                <div className="font-['corporate-s'] text-gray-800 pl-6 mr-18 text-sm sm:textbase leading-relaxed">
                  <p>
                    Click on a TWA region listed below to reach out to the local
                    contact.
                  </p>
                </div>
              </div>
            </div>
            <Community />
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default WhoWeAre;
